// src/pages/VendorHybridBulkUploadPage.jsx
import VendorHybridBulkUpload from '../components/Vendor/VendorHybridBulkUpload';

export const VendorHybridBulkUploadPage = () => {
    
  return <VendorHybridBulkUpload />;
};

export default VendorHybridBulkUploadPage;